import axios from "axios";
import { toast } from "react-toastify";
import superAdminAuthHeader from "./superAdminAuthHeader";

export const fetchAllCompanies = (filters = {}) => {
  return new Promise((resolve, reject) => {
    const query_string = new URLSearchParams(filters).toString();
    
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/company?${query_string}`, {
        headers: superAdminAuthHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const fetchOneCompany = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/company/${id}`, {
        headers: superAdminAuthHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const createCompany = (data) => {
  return new Promise((resolve, reject) => {
    if (!data) return resolve(null);

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/company/`, data, {
        headers: superAdminAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateCompany = (data, id) => {
  return new Promise((resolve, reject) => {
    if (!id || !data) return resolve(null);

    axios
      .put(`${process.env.REACT_APP_BASE_URL}/company/${id}`, data, {
        headers: superAdminAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const deleteCompany = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);

    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/company/${id}`, {
        headers: superAdminAuthHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};
